export default {
    main: {},
    mainState: {
        components: {}
    }
};
